.title {
    font-size: 22px;
    font-family: LustTextMedium;
    font-style: italic;
    color: #243a5c;
    padding-top: 10px;
    padding-bottom: 10px;
}

.titleUnderline {
    border-bottom: 1px dashed #d0d5dd;
}
